import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import styled from 'styled-components';
import { getHeaderName } from 'routes/projects/list-v2/grid/get-header-name';
import { OverlayWrapper, Row, Col1, Col2 } from './style';

export const DropArea = styled.div`
  min-height: var(--spacing-09);
  width: 100%;
  margin: 0;
`;
export const Overlay = ({ field }) => {
  if (field) {
    return (
      <OverlayWrapper>
        <Row isOverlay>
          <Col1>{getHeaderName(field)}</Col1>
          <Col2 />
        </Row>
      </OverlayWrapper>
    );
  }

  return null;
};

export const DraggableField = ({ children, id, isPublished }) => {
  const {
    attributes,
    listeners,
    setNodeRef: draggableRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: id?.toString() ?? '', disabled: isPublished });
  const draggabeStyle = transform
    ? {
        transform: CSS.Translate.toString(transform),
        transition: transition || undefined,
        cursor: 'grab',
        backgroundColor: isDragging ? 'var(--white-100)' : 'var(--white-100)',
        color: isDragging ? 'inherit' : 'inherit',
        opacity: isDragging ? '80%' : '100%',
        border: isDragging ? '2px dashed var(--blue-60)' : 'none',
        minHeight: 'var(--spacing-07)',
        margin: 0,
      }
    : undefined;

  if (isDragging) {
    return (
      <DropArea
        style={draggabeStyle}
        ref={draggableRef}
        {...listeners}
        {...attributes}
      />
    );
  }

  return (
    <div
      style={draggabeStyle}
      ref={draggableRef}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
};
